import { render, staticRenderFns } from "./base-flag.vue?vue&type=template&id=587c8206&scoped=true"
import script from "./base-flag.vue?vue&type=script&setup=true&lang=js"
export * from "./base-flag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-flag.vue?vue&type=style&index=0&id=587c8206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587c8206",
  null
  
)

export default component.exports